export enum BROWSER_EXTENSION_CUSTOM_EVENT_TYPES {
	StartManualTest = 'startManualTest',
	RequestToken = 'requestToken',
	ReceiveToken = 'responseToken',
	SetToken = 'setToken'
}
